import { getInstitutionListApi } from '../api/institutions';
import types from '../types';

export const getInstitutionList = (jwt) => async (dispatch) => {
  try {
    dispatch({ type: types.reducerTypes.INSTITUTION_LIST_PENDING });
    const data = await getInstitutionListApi(jwt);
    dispatch({ type: types.reducerTypes.INSTITUTION_LIST_SUCCESS, payload: data });
  } catch (e) {
    console.log(e);
    dispatch({ type: types.reducerTypes.INSTITUTION_LIST_ERROR, payload: 'Unexpected Error!' });
  }
};
